import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom"
import Spinner from "./views/Spinner/Spinner";
import { store, persistor } from "./store/Store.js";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LanguageProvider } from "./contexts/ThemeContext/ThemeContext.js";


export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: true,
    },
  },
});



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<Spinner />}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <Provider store={store}>
          <LanguageProvider>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </LanguageProvider>
        </Provider>
      </Router>
    </QueryClientProvider>
  </Suspense>
);



